import React, { useEffect, useState } from "react";
import moment from 'moment'


import {
    lsLogo,
    dsLogo,
    crLogo,
    trLogo
} from "./Images";

function difference(d1, d2) {
    var m = moment(d1);
    var years = m.diff(d2, 'years');
    m.add(-years, 'years');
    var months = m.diff(d2, 'months');
    m.add(-months, 'months');
    var days = m.diff(d2, 'days');
    return { years: years, months: months, days: days };
}

const skillsObj = {
    "programming": {
        "title": "Programming",
        "skills": [
            "Node.js", "Python", "Scala", "Spark", " Lua scripting", "Shell scripting"
        ]
    },
    "frameworks": {
        "title": "Frameworks",
        "skills": [
            "Express.js", "Flask", "Django", "FastAPI", "Koa js", "Gatsby js"
        ]
    },
    "databases": {
        "title": "Databases",
        "skills": [
            "MySQL", "PostgreSQL", "SQL Server", "MongoDB"
        ]
    },
    "web_development" : {
        "title": "Web Development",
        "skills": [
            "MEAN","MERN","Next.js","Remix","Redux"
        ]
    },
    "cms" : {
        "title": "CMS",
        "skills": [
            "Strapi","Contentful"
        ]
    },
    "genai" : {
        "title": "Gen AI",
        "skills": [
            "Open AI","LangChain", "Vector Databases","LangGraph"
        ]
    },
    "cloud_services": {
        "title": "Cloud Services",
        "skills": [
            {
                "skill":"GCP",
                "subSkills": ["App Engine","Cloud Build","Dialogflow CX","Pub/Sub","Functions","API Gateway","VM"]
            },
            {
                "skill": "AWS",
                "subSkills": ["lamda", "EC2", "Sage Maker", "Glue","S3"]
            }, {
                "skill":"Azure",
                "subSkills": ["Function App", "App service", "VM", "Speech to Text","Text to Speech","Bot service"]
            },
            "Netlify",
            "Gatsby"
        ]
    },
    "other_services" : {
        "title" : "Other Services",
        "skills": [
            "Twilio", "Sendgrid", "Contentful"
        ]
    },
    "deployment": {
        "title": "Deployment",
        "skills": [
            "Docker", "Using Cloud Services", "NGINX", "Apache Webserver"
        ]
    },
    "others": {
        "title": "Others",
        "skills": [
            "Shopify App", "Shopify GraphQL and REST API",
            "Google Assistant", "Alexa", "LUIS", "Microsfot Teams Bot","Telegram bot","ML and NLP","Chatbots",
            "Voice bots",
            "Analytics tool",
            "Making generic features for products",
            "E-commerce related products",
            "Application scalability and load balancing",
            "Architecting of solution as per client requirements",
            "Data Engineering",
            "Serverless solutions",
            "Secure API implementation"
        ]
    }
}

const Skill = ({ skillObj }) => {
    return (
        <div>
            <span className="skillTitle">
                {skillObj.title}
            </span>
            <ul>
                {skillObj.skills.map((v,i) => {
                    if (typeof (v) == "object") {
                        return (<li key={`skill_${i}_${v.skill}`}>{v.skill}
                            <ul>
                                {v.subSkills.map((subSkill) => (<li key={`skill_${i}_${v.skill}_${subSkill}`}>{subSkill}</li>))}
                            </ul>
                        </li>)
                    } else {
                        return (
                            <li key={`skill_${i}`}>{v}</li>
                        )
                    }
                })
                }
            </ul>
        </div>
    )
}
const About = () => {
    const [lastedExp, setLastedExp] = useState(difference(moment(), moment("05.12.2024", "DD.MM.YYYY")));
    const [totalExp, setTotalExp] = useState(difference(moment(), moment("01.04.2016", "DD.MM.YYYY")));


    useEffect(() => {
        setLastedExp(difference(moment(), moment("05.12.2024", "DD.MM.YYYY")));
        setTotalExp(difference(moment(), moment("01.04.2016", "DD.MM.YYYY")));
    }, []);

    const workExpData = {
        "title": "Work Experience",
        "summary": [
            `I have a total of ${totalExp.years}+ years of experience in product and project development and deployment.`,
            `I have been working on building Gen AI project -  Multiple usecases(Fullstack development).`,
            `For 3 years, I worked on Shopify app development and e-commerce projects.`,
            `I have worked on Shopify apps and headless e-commerce store implementations end-to-end.`,
            "Most of my work involves developing interesting products such as analytics tools and chatbot products.",
            "I have hands-on experience with multiple products and projects from scratch to deployment.",
            "I have worked on multiple cloud platforms, including AWS, GCP, and Azure.",
            "I enjoy research, innovation, implementation, and creating solutions. I am always happy to work with new technologies.",
            "I have started writing technical blogs on <a class='anchor anchor-link' href='https://medium.com/@karthik.skreddy24' target='_blank'>Medium<i class='fa fa-external-link' aria-hidden='true'></i></a>.",
            "I also started a <a class='anchor anchor-link' href='https://www.youtube.com/channel/UCTbKSzEamYTYYY_c2yH1fEA' target='_blank'>YouTube channel<i class='fa fa-external-link' aria-hidden='true'></i></a> where I upload coding and technical videos.",
            "Last but not least, here is my poetry and stories blog: <a class='anchor anchor-link' href='https://t-lithub.blogspot.in/' target='_blank'>blog<i class='fa fa-external-link' aria-hidden='true'></i></a>."
        ].join("</li><li>")
    };
    const workExperience = [
        {
            "jobTitle": "Architect - Full Stack | Engineering Manager",
            "company": {
                "name": "Tredence",
                "website": "https://www.tredence.com/",
                "logo": trLogo
            },
            "employment": `Dec 2024 - Present ${lastedExp.years != 0 ? "·" + lastedExp.years + " yrs" : ""} ${lastedExp.months != 0 ? "·" + lastedExp.months + " mos" : ""}`,
            "summary": "Building Gen AI Application - Multiple Usecases"

        },
        {
            "jobTitle": "Technical Lead",
            "company": {
                "name": "Coderapper | eCommerce Agency",
                "website": "http://coderapper.com/",
                "logo": crLogo
            },
            "parentCompany": {
                "name": "Sedin Technologies",
                "website": "https://sedintechnologies.com/",
            },
            "employment": "Sep 2021 - Dec 2025 · 3 yrs 4 mos",
            "summary": "Marsel: Personalize & Upsell Recommednations App <br/> Buddhi: AI Conversational chatbot App"

        },
        {
            "jobTitle": "Associate Big Date Engineer",
            "company": {
                "name": "Data Semantics",
                "website": "https://datasemantics.co/",
                "logo": dsLogo
            },
            "employment": "Dec 2018 - Aug 2021 · 2 yrs 9 mos",
            "summary": "Product: SiriusBOT – ChatBOT/VoiceBOT with ML and NLP integration"
        },
        {
            "jobTitle": "Software Engineer",
            "company": {
                "name": "Lead Semantics",
                "website": "https://leadsemantics.com/",
                "logo": lsLogo
            },
            "employment": "Apr 2016 - Dec 2018 · 2 yrs 9 mos",
            "summary": "Product: Hiddime – Advanced Cloud BI tool with ML Integration"
        }
    ];
    
    return (
        <div>
            <div className={`sectionDiv aboutMe workExpSectionDiv`} id="aboutMe">
                <div className="headerDiv">
                    <div className="heading2"><i className="fa fa-laptop" aria-hidden="true"></i>{workExpData.title}
                    </div>
                </div>
                <div className="sectionBody">
                    <div className="workExperience">
                        <ul>{
                            workExperience.map((v,i) =>
                            (<li key={"work_exp"+i}>
                                <div className="workExperienceDiv">
                                    <div className="companyLogo"><img src={v.company.logo} /></div>
                                    <div className="workExperienceSubDiv">
                                        <span className="jobTitle">{v.jobTitle}</span>
                                        <span className="companyName"><a className="anchor anchor-link" href={v.company.website} target={"_blank"}>{v.company.name}<i className="fa fa-external-link" aria-hidden="true"></i></a></span>
                                        {v.parentCompany && <span className="companyName"><a className="anchor anchor-link" href={v.parentCompany.website} target={"_blank"}>{v.parentCompany.name}<i className="fa fa-external-link" aria-hidden="true"></i></a></span>}
                                        <span className="jobsummary" dangerouslySetInnerHTML={{__html: v.summary}}></span>
                                        <span className="employment">{v.employment}</span>
                                    </div>
                                </div>
                            </li>)
                            )
                        }
                        </ul>
                    </div>
                </div>
            </div>
            <div className={`sectionDiv aboutMe skillSectionDiv`} id="aboutMe">
                <div className="headerDiv">
                    <div className="heading2"><i className="fa fa-cogs" aria-hidden="true"></i>Skills &#38; technologies
                    </div>
                </div>
                <div className="sectionBody">
                    <div className="skillSectionBody">
                        <div>
                            <Skill skillObj={skillsObj["programming"]} />
                            <Skill skillObj={skillsObj["frameworks"]} />
                            <Skill skillObj={skillsObj["web_development"]} />
                            <Skill skillObj={skillsObj["databases"]} />
                        </div>
                        <div>
                            <Skill skillObj={skillsObj["genai"]} />
                            <Skill skillObj={skillsObj["cloud_services"]} />
                        </div>
                        <div>
                            <Skill skillObj={skillsObj["cms"]} />
                            <Skill skillObj={skillsObj["deployment"]} />
                            <Skill skillObj={skillsObj["others"]} />
                        </div>
                    </div>
                </div>
            </div>
            <div className={`sectionDiv aboutMe summarySectionDiv`} id="aboutMe">
                <div className="headerDiv">
                    <div className="heading2"><i className="fa fa-list-alt" aria-hidden="true"></i>Profile Summary
                    </div>
                </div>
                <div className="sectionBody">
                    <div className="summarySectionBody">
                        <ul className="aboutMeList" dangerouslySetInnerHTML={{ __html: "<li>" + workExpData.summary + "</li>" }} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default About;